import newAPIClient from '../api/newApi';

export const getEvents = (): Promise<void | any> => {
  return newAPIClient.get('/event').then((res: any) => {
    return res.data;
  });
};
